var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99083 1.83166H6.30271V0.196646C6.30206 0.12176 6.25974 0.0537616 6.19327 0.0204967C6.12679 -0.012603 6.0475 -0.00522946 5.98832 0.0398322L2.89421 2.53886C2.84767 2.57655 2.8206 2.63357 2.8206 2.69387C2.8206 2.75401 2.84767 2.81103 2.89421 2.84872L5.98832 5.34594C6.04783 5.391 6.12744 5.39838 6.19408 5.36462C6.26072 5.33103 6.30271 5.26221 6.30271 5.18699V3.55395H6.99083C8.36984 3.55395 9.69469 4.09617 10.685 5.06623C11.6752 6.03611 12.2531 7.35748 12.296 8.75046C12.3392 10.1434 11.844 11.4986 10.9156 12.5291C9.98699 13.5596 8.69813 14.1844 7.32173 14.2712C5.9455 14.3579 4.58968 13.9001 3.54161 12.9943C2.4937 12.0884 1.83556 10.8059 1.70684 9.41836C1.69776 9.31578 1.61231 9.23729 1.51033 9.23762H0.197143C0.142178 9.23745 0.0896463 9.26056 0.0523515 9.30136C0.0148974 9.34216 -0.00375082 9.39672 0.000628251 9.45211C0.139094 11.2947 0.984323 13.0097 2.3562 14.2313C3.72824 15.4527 5.5181 16.0842 7.34419 15.991C9.17037 15.8977 10.8881 15.0869 12.1309 13.7318C13.374 12.3767 14.0438 10.5844 13.9978 8.73706C13.9517 6.88987 13.1932 5.13392 11.8841 3.8438C10.5752 2.55372 8.81901 1.83158 6.99075 1.83141L6.99083 1.83166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/regenerate.ca2b8cce7717206d672e61447077e270.svg";
export { ForwardRef as ReactComponent };